import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from '../../../utils/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from '../action-type.util';

import { ITournamentMatch, defaultValue } from '../../model/tournament-match.model';

export const ACTION_TYPES = {
  FETCH_TOURNAMENTMATCH_LIST: 'tournamentMatch/FETCH_TOURNAMENTMATCH_LIST',
  FETCH_TOURNAMENTMATCH: 'tournamentMatch/FETCH_TOURNAMENTMATCH',
  CREATE_TOURNAMENTMATCH: 'tournamentMatch/CREATE_TOURNAMENTMATCH',
  UPDATE_TOURNAMENTMATCH: 'tournamentMatch/UPDATE_TOURNAMENTMATCH',
  DELETE_TOURNAMENTMATCH: 'tournamentMatch/DELETE_TOURNAMENTMATCH',
  RESET: 'tournamentMatch/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<ITournamentMatch>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type TournamentMatchState = Readonly<typeof initialState>;

// Reducer

export default (state: TournamentMatchState = initialState, action): TournamentMatchState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_TOURNAMENTMATCH_LIST):
    case REQUEST(ACTION_TYPES.FETCH_TOURNAMENTMATCH):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_TOURNAMENTMATCH):
    case REQUEST(ACTION_TYPES.UPDATE_TOURNAMENTMATCH):
    case REQUEST(ACTION_TYPES.DELETE_TOURNAMENTMATCH):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_TOURNAMENTMATCH_LIST):
    case FAILURE(ACTION_TYPES.FETCH_TOURNAMENTMATCH):
    case FAILURE(ACTION_TYPES.CREATE_TOURNAMENTMATCH):
    case FAILURE(ACTION_TYPES.UPDATE_TOURNAMENTMATCH):
    case FAILURE(ACTION_TYPES.DELETE_TOURNAMENTMATCH):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_TOURNAMENTMATCH_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    case SUCCESS(ACTION_TYPES.FETCH_TOURNAMENTMATCH):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_TOURNAMENTMATCH):
    case SUCCESS(ACTION_TYPES.UPDATE_TOURNAMENTMATCH):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_TOURNAMENTMATCH):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/tournament-matches';

// Actions

export const getEntities: ICrudGetAllAction<ITournamentMatch> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_TOURNAMENTMATCH_LIST,
    payload: axios.get<ITournamentMatch>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export const getEntity: ICrudGetAction<ITournamentMatch> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_TOURNAMENTMATCH,
    payload: axios.get<ITournamentMatch>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<ITournamentMatch> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_TOURNAMENTMATCH,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<ITournamentMatch> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_TOURNAMENTMATCH,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<ITournamentMatch> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_TOURNAMENTMATCH,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
